import {
  BaseDriver,
  ComponentFactory,
  DriverFactory,
} from '@wix/wix-ui-test-utils/driver-factory';

export interface CircularProgressBarCoreDriver extends BaseDriver {
  /** Returns boolean that indicates if the success icon exists */
  isSuccessIconDisplayed(): boolean;
  /** Returns boolean that indicates if the error icon exists */
  isErrorIconDisplayed(): boolean;
  /** Returns boolean that indicates if the progress percentages text exists */
  isPercentagesProgressDisplayed(): boolean;
  /** Returns boolean that indicates if the label text exists */
  isLabelDisplayed(): boolean;
  /** Get the text content displayed */
  getLabelTextContent(): string | null | undefined;
  /** Get the progress percentages value */
  getValue(): string | null | undefined;
  /** Returns true if has progress completed (value is 100) */
  isCompleted(): boolean;
  /** Returns true if single element with given data-hook rendered*/
  isSingleElementRendered(dataHook: string): boolean;
}

export const circularProgressBarCoreDriverFactory: DriverFactory<
  CircularProgressBarCoreDriver
> = ({ element }: ComponentFactory) => {
  const getElement = (dataHook: string) =>
    element?.querySelector(`[data-hook="${dataHook}"]`);
  const getValue = () =>
    !element ? null : getElement('progress-indicator')?.innerHTML;
  const getByLabelText = () =>
    !element ? null : getElement('label')?.innerHTML;

  const driver = {
    exists: () => !!element,
    isSuccessIconDisplayed: () => !!getElement('success-icon'),
    isErrorIconDisplayed: () => !!getElement('error-icon'),
    getLabelTextContent: () => getByLabelText(),
    isLabelDisplayed: () => !!getElement('label'),
    isPercentagesProgressDisplayed: () => !!getElement('progress-indicator'),
    getValue: () => getValue(),
    isCompleted: () => getValue() === '100',
    isSingleElementRendered: (dataHook: string) =>
      element?.querySelectorAll(`[data-hook="${dataHook}"]`).length === 1,
  };

  return driver;
};
